import React from "react";
import KeyValTable from "../Common/KeyValTable";
const Address = ({ data = {} }) => {
  return (
    <div>
      <h2>Address</h2>
      <KeyValTable data={data} />
    </div>
  );
};
export default Address;
